import React, { Component } from "react";
import { clearErrors } from "../../../actions/errorsActions";
import SideMenuOffices from "../../../components/layout/SideMenuOffices";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Navigate from "../../../components/Navigate/Navigate";
import UserSettingsCard from "../../../components/Cards/UserSettingsCard";
import Input from "../../../components/common/Input";
import Dropdown from "../../../components/common/Dropdown";
import Spinner from "../../../components/common/Spinner";
import Btn from "../../../components/common/Btn";
import { getGlobalUsers } from "../../../actions/userActions";
import { accountType } from "../../../enums/accountType";

import { roles } from "../../../enums/roles";
import isEmpty from "../../../validation/isEmpty";

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;
class AdminUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      mounted: false,
      globalUsers: this.props.users && this.props.users.globalUsers,
      active: "",
      user_search: "",
      auth: {},
      errors: {},
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let update = {};
    if (nextProps.auth) {
      var tokenUserOffices = nextProps.auth.user.offices;
      update.singleOffice = tokenUserOffices && tokenUserOffices.length === 1 ? true : false;
      if (nextProps.auth !== prevState.auth) {
        if (!nextProps.auth.isAuthenticated || !accountType.USER) {
          nextProps.history.push("/");
        }
        if (
          (nextProps.auth.user.offices &&
            nextProps.auth.user.offices[0] &&
            nextProps.auth.user.offices[0].user_role_office.role.value !== roles.SUPERADMINISTRATOR) ||
          isEmpty(nextProps.auth.user.offices)
        ) {
          nextProps.history.push("/");
        }

        if (nextProps.errors) {
          update.errors = nextProps.errors;
        }
        update.auth = nextProps.auth;
      }

      if (nextProps.users.globalUsers !== prevState.globalUsers) {
        update.globalUsers = nextProps.users.globalUsers;

        var globalUsers = nextProps.users.globalUsers;
        var mappedglobalUsers = [];
        globalUsers &&
          globalUsers.map((user) => {
            return mappedglobalUsers.push(user);
          });
        update.globalUsersMapped = mappedglobalUsers;
        update.globalUsersUpdated = true;
      }
    }
    return Object.keys(update).length ? update : null;
  }
  componentDidMount() {
    this.props.getGlobalUsers();
  }
  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.searchUsers();
    });
  }
  searchUsers() {
    var filters = {};
    if (!isEmpty(this.state.user_search)) {
      filters.user_search = this.state.user_search;
    }

    if (!isEmpty(this.state.role)) {
      filters.role = this.state.role;
    }

    if (!isEmpty(this.state.active) && !isNaN(this.state.active) && parseInt(this.state.active) !== 0) {
      if (parseInt(this.state.active) === 2) {
        filters.active = parseInt(this.state.active);
      } else if (parseInt(this.state.active) === 3) {
        filters.active = parseInt(this.state.active);
      }
    }
    if (Object.keys(filters).length > 0) {
      this.setState({ filters }, () => {});

      this.props.getGlobalUsers(filters);
    } else {
      this.props.getGlobalUsers();
    }
  }
  timer = null;
  handleChange = (e) => {
    clearTimeout(this.timer);
    this.setState({ user_search: e.target.value }, () => {});
    this.timer = setTimeout((timeout) => {
      this.triggerChange(timeout);
    }, WAIT_INTERVAL);
  };

  handleKeyDown = (e) => {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange(e);
    }
  };

  clearFilters() {
    this.setState(
      {
        user_search: "",
        active: "",
        role: "",
      },
      () => {
        this.searchUsers();
      }
    );
  }
  triggerChange = (e) => {
    this.setState({ user_search: this.state.user_search }, () => {
      this.searchUsers();
    });
  };

  render() {
    const { loading } = this.props.users;

    var content;
    if (!this.state.globalUsersUpdated || loading) {
      content = <Spinner />;
    } else {
      content = <UserSettingsCard users={this.state.globalUsersMapped} props={this.props} filters={this.state.filters} />;
    }
    return (
      <div className="grid-menu-container">
        <div className="menu-grid">
          <div className="menu">
            <SideMenuOffices props={this.props} />
            <hr />
          </div>
        </div>
        <div className="main-grid">
          <div className="main">
            <Navigate title={"Users"} link={`/admin/settings`} />
            <div className="search-container">
              <div className="search-container-search">
                <Input
                  placeholder="Search users..."
                  name={"user_search"}
                  noTitle={true}
                  onChange={(e) => this.handleChange(e)}
                  onKeyDown={this.handleKeyDown}
                  value={this.state.user_search}
                />
              </div>
              <div className="search-container-filter">
                <Dropdown
                  placeholder="Role"
                  options={[
                    {
                      id: roles.SUPERADMINISTRATOR,
                      title: "Super Administrator",
                    },
                    {
                      id: roles.GLOBALVIEWER,
                      title: "Global Viewer",
                    },
                  ]}
                  onChange={(e) => this.onChange(e)}
                  name={"role"}
                  value={this.state.role}
                  noTitle={true}
                />
              </div>
              <div className="search-container-filter">
                <Dropdown
                  placeholder="Active"
                  options={[
                    { id: 1, title: "All" },
                    { id: 2, title: "Activated" },
                    { id: 3, title: "Deactivated" },
                  ]}
                  onChange={(e) => this.onChange(e)}
                  name={"active"}
                  value={this.state.active}
                  noTitle={true}
                />
              </div>
              <div className="search-container-clear mb-1">
                <Btn label="Clear" className="btn btn-secondary" onClick={(e) => this.clearFilters()} />
              </div>
            </div>

            {content}
          </div>
        </div>
      </div>
    );
  }
}

AdminUsers.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  users: state.users,
  // roles: state.roles,
});

export default connect(mapStateToProps, { getGlobalUsers, clearErrors })(withRouter(AdminUsers));
